const initSpecialOffers = () => {
    const seeMoreButton = document.getElementsByClassName('special-offers-panel__see-more');
    const secondList = document.getElementsByClassName('special-offers-panel__list --second');
    if(seeMoreButton.length === 0 || secondList.length === 0) {
        return;
    }

    const seeMoreButtonContainer = seeMoreButton[0];
    const seeMoreButtonText = seeMoreButtonContainer.getElementsByClassName('button__text')[0];

    seeMoreButton[0].addEventListener('click', () => {
        if(secondList[0].classList.contains('--open')) {
            Velocity(secondList[0], 'slideUp');
            secondList[0].classList.remove('--open');
            seeMoreButtonText.innerText = 'See more special offers';
            return;
        }
        secondList[0].classList.add('--open');
        Velocity(secondList[0], 'slideDown');
        seeMoreButtonText.innerText = 'See fewer offers';
    });
};

export default initSpecialOffers;
